import logo from './logo.webp';

import './App.css';
import './componenet/css/style.css';

import './componenet/css/responsive.css';

import {Footer} from './componenet/home/footer';
import Servicehome from './componenet/home/servicehome';

import Homecontent from './componenet/data/homecontent';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import  {Topheader}  from './componenet/common/topheader';

import {Innerbanner} from './componenet/common/innerbanner';
import { Homepage } from './componenet/homepage';
import { Contactus } from './componenet/contactus';



function App() {
  return (


   <div className='container-fluid p-0' >
<i icon={faWhatsapp}></i>

<Topheader></Topheader>
<Homepage></Homepage>
<Innerbanner></Innerbanner>
<Footer/>


<Contactus></Contactus>


</div>








  );
}

export default App;



